import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {RealityCheckModule} from '@gongxigames/framework/slot/modules/realitycheck/RealityCheckModule';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';

export class RealityCheckShowingState extends ModuleState<null, RealityCheckModule> {
    protected waitFeatureFinished = false;

    onEnterState(): void {
        if (this.module.gameInFeature) {
            this.waitFeatureFinished = true;
        }

        if (!this.waitFeatureFinished) {
            this.module.showPopup();
        }
    }

    onLeaveState(): void {
        this.waitFeatureFinished = false;
    }

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.FEATURE_FINISHED, this.onFeatureFinished.bind(this));
        this.setEventHandler(FlowModuleEvents.ROUND_ENDED, this.onFeatureFinished.bind(this));
    }

    protected onFeatureFinished(): void {
        if (this.waitFeatureFinished) {
            this.waitFeatureFinished = false;
            this.module.showPopup();
        }
    }
}
